import { render, staticRenderFns } from "./app-embed.vue?vue&type=template&id=6f0aa718"
import script from "./app-embed.vue?vue&type=script&lang=js"
export * from "./app-embed.vue?vue&type=script&lang=js"
import style0 from "./app-embed.vue?vue&type=style&index=0&id=6f0aa718&prod&lang=scss"
import style1 from "./app-embed.vue?vue&type=style&index=1&id=6f0aa718&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports